import React from 'react';
import {Box, Stack, TextField} from '@mui/material';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import RequiredCheckbox from './Shared/RequiredCheckbox';

const SingleLine = ({
                        index,
                        id,
                        value,
                        onChange,
                        description,
                        validation,
                        enableValidation,
                        isEditMode,
                        isFormLive,
                        validationError
                    }) => {
    return (
        <Box>
            {isEditMode
                ? <>
                    <TextField sx={{my: 1}} fullWidth multiline value={description}
                               onChange={e => onChange({index, description: e.target.value})}
                               label={!description ? 'Write a question for a short answer' : null}
                               disabled={isFormLive}
                               InputLabelProps={{
                                   shrink: false,
                               }}/>
                    <Stack flexDirection="row"
                           justifyContent="space-between"
                           gap={3}>
                        <RequiredCheckbox enableValidation={enableValidation} index={index} onChange={onChange}
                                          text={'Enable validation?'} isFormLive={isFormLive}/>
                        <Box>
                            {enableValidation &&
                                <>
                                    <Typography mb={1}>Required character length:</Typography>
                                    <TextField type='number' sx={{width: '100px', mr: 2}} label={'Minimum'}
                                               value={validation?.min} inputProps={{max: validation?.max, min: 0}}
                                               disabled={isFormLive}
                                               onChange={e => parseInt(e.target.value) >= 0 && onChange({
                                                   index,
                                                   validation: {
                                                       min: parseInt(e.target.value) <= parseInt(validation.max) ? e.target.value : validation.max,
                                                       max: validation.max
                                                   }
                                               })}
                                    />
                                    <TextField type='number' sx={{width: '100px'}} label={'Maximum'}
                                               value={validation?.max}
                                               inputProps={{min: validation?.min}}
                                               disabled={isFormLive}
                                               onChange={e => e.target.value >= 1 && onChange({
                                                   index,
                                                   validation: {
                                                       min: validation.min,
                                                       max: parseInt(e.target.value) >= parseInt(validation.min) ? e.target.value : validation.min
                                                   }
                                               })}
                                    />
                                </>
                            }
                        </Box>
                    </Stack>
                </>
                : <>
                    <Typography>{description}{enableValidation ? '*' : ''}</Typography>
                    <TextField fullWidth value={value} required={enableValidation}
                               inputProps={enableValidation && {maxLength: validation.max, minLength: validation.min}}
                               onChange={e => onChange({id, value: e.target.value})}
                               error={validationError} helperText={validationError}
                    />
                </>
            }
        </Box>
    );
};

SingleLine.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    index: PropTypes.number,
    validation: PropTypes.object,
    description: PropTypes.string,
    onChange: PropTypes.func,
    enableValidation: PropTypes.bool,
    isEditMode: PropTypes.bool,
    isFormLive: PropTypes.bool,
    validationError: PropTypes.string,
};

export default SingleLine;